import { versionColumns, versionRows } from "@/mocks/home";

export default function VersionCompare() {
  return (
    <section id="versions" className="w-full bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-label tracking-widest text-primary-700">COMPARE</span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            安卓版、iOS 版与平板版怎么选
          </h2>
          <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">
            核心阅读能力一致，差别主要在安装方式与更新机制上。下面按常见维度做了对照，方便你快速决定。
          </p>
        </div>

        <div className="mt-10 hidden md:block rounded-lg border border-background-200 bg-background-50 overflow-hidden">
          <table className="w-full border-collapse text-sm">
            <thead>
              <tr className="bg-secondary-100">
                {versionColumns.map((col, index) => (
                  <th
                    key={col}
                    className={`px-5 py-4 font-label font-medium text-secondary-900 ${
                      index === 0 ? "text-left" : "text-center"
                    }`}
                  >
                    {col}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {versionRows.map((row, rowIndex) => (
                <tr key={row[0]} className={rowIndex % 2 === 1 ? "bg-background-100/60" : ""}>
                  {row.map((cell, cellIndex) => (
                    <td
                      key={`${row[0]}-${cellIndex}`}
                      className={`px-5 py-4 border-t border-background-200 ${
                        cellIndex === 0
                          ? "text-left font-medium text-foreground-950"
                          : "text-center text-foreground-600"
                      }`}
                    >
                      {cell}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-8 md:hidden space-y-4">
          {versionRows.map((row) => (
            <div key={row[0]} className="rounded-lg border border-background-200 bg-background-50 p-4">
              <h3 className="font-heading text-sm font-bold text-foreground-950">{row[0]}</h3>
              <dl className="mt-3 grid grid-cols-1 gap-2">
                {versionColumns.slice(1).map((col, index) => (
                  <div key={col} className="flex items-center justify-between gap-4 text-sm">
                    <dt className="text-foreground-500">{col}</dt>
                    <dd className="text-right text-foreground-800">{row[index + 1]}</dd>
                  </div>
                ))}
              </dl>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}